import { Permissions } from './Permission';

/**
 * @typedef {Object} Unit
 * @property {String} deno
 * @property {Number} prestad
 * @property {Number} unidadGestion
 */

/**
 * @typedef {Object} SurveyResponse
 * @property {String} message
 * @property {String} status
 * @property {String} solicitar_datos
 */

/**
 * @typedef {Object} UserConfig
 * @property {Object} userDetail
 * @property {Boolean} userHasAcceptedTerms
 * @property {Number} userHasDOC24Permission
 * @property {Boolean} isCircle
 * @property {SurveyResponse} userSurveyResponse
 * @property {Permissions} userPermissions
 * @property {Unit[]} managementUnit
 */

/**
 * @typedef {Object} SpecificModel
 * @property {Boolean} admin
 * @property {String} apellidoPrestador
 * @property {Number} cuitPrestador
 * @property {String} emailPrestador
 * @property {Number} codPrestador
 * @property {String} habilitaADP
 * @property {Number} idPrestador
 * @property {Number} idUsuario
 * @property {String} nombrePrestador
 * @property {String} razonSocialPrestador
 * @property {Any} soloLectura

 */

/**
 * @typedef {Object} PeopleType
 * @property {{id: String, descripcion: String}} condicionIva
 * @property {String} tipo
 * @property {String} razonSocial
 * @property {String} abreviatura
 * @property {String} apeRazonSocial
 * @property {String} nombreAbre
 */

/**
 * @typedef {Object} UserDetail
 * @property {SpecificModel} modelEspecifico
 * @property {String} apeRazonSocial
 * @property {} fechaBaja
 * @property {String} estado
 * @property {String} facturaCredito
 * @property {PeopleType} tipoPersona
 * @property {String} habilitaADP
 * @property {} listadoLugarDeAtencion
 * @property {} prestadorPagosGrupos
 * @property {} fechaInhabilitacion
 * @property {} validaContratoPadron
 * @property {String} nombreAbre
 * @property {String} prestadorObservaciones
 * @property {} gananExenHasta
 * @property {Object} domicilio
 * @property {} prestadorCapAssignment
 * @property {String} observacion1
 * @property {} calificaciones
 * @property {} prestadorEntes
 * @property {String} observacion2
 * @property {} prestadorMails
 * @property {} listadoLugarDeAtencionPotencial
 * @property {String} controlaBoletin
 * @property {Number} id
 * @property {{id: String, descripcion: String}} tipoPrestador
 * @property {Boolean} habilitado
 * @property {String} telefono
 * @property {} prestadorMalaPraxisPoliza
 * @property {} codigoSAP
 * @property {} observacion
 * @property {String} habilitaWeb
 * @property {} fechaModificacion
 * @property {Number} fechaAlta
 * @property {Array} telefonosPrestador
 * @property {String} ivaReten
 * @property {String} ingreBrutosReten
 * @property {String} gananReten
 * @property {String} telefonoCelular
 * @property {String} enviaBoletin
 * @property {String} cuit
 * @property {String} ingreBrutosNro
 * @property {} prestadorUnidadGestion
 * @property {String} direccionEmail
 * @property {String} numeroLegajo
 * @property {String} tipoEntidad
 */

/**
 * @typedef {Object} AuthData
 * @property {UserDetail} userDetail
 * @property {Boolean} userHasAcceptedTerms
 * @property {Number} userHasDOC24Permission
 * @property {Boolean} isCircle
 * @property {SurveyResponse} userSurveyResponse
 * @property {Permissions} userPermissions
 * @property {Unit[]} managementUnit
 * @property {String} token
 * @property {string} tokenExpirationDate
 */

/**
 * @typedef {Object} LoginResponse
 * @property {SpecificModel} modelEspecifico
 * @property {String} token
 * @property {string} exp
 */

const User = {};

export default User;
